import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Button, TextField } from '../components/ui-kit';

const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  contentText,
  confirmButtonText,
  confirmButtonColor = 'primary',
  cancelButtonText = 'Cancel',
  showTextField = false,
  textFieldPlaceholder = '',
  textFieldLabel = '',
  textFieldValue = '',
  onTextFieldChange = () => {},
  textFieldProps = {},
  dialogProps = {},
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ elevation: 0, sx: { borderRadius: '12px' } }}
      {...dialogProps}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{contentText}</DialogContentText>
        {showTextField && (
          <TextField
            autoFocus
            margin="dense"
            type="text"
            fullWidth
            value={textFieldValue}
            onChange={onTextFieldChange}
            placeholder={textFieldPlaceholder}
            sx={{ mt: 2 }}
            {...textFieldProps}
          />
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="outlined">
          {cancelButtonText}
        </Button>
        <Button
          onClick={onConfirm}
          variant={['Ban', 'Delete'].includes(confirmButtonText) ? 'contained' : 'contained'}
          color={['Ban', 'Delete'].includes(confirmButtonText) ? 'primary' : confirmButtonColor}
        >
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
